import type { ReactNode } from 'react';
import { cn } from '../cn';

export type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

export function Badge({ tone = 'neutral', dot, children }: { tone?: Tone; dot?: boolean; children: ReactNode }) {
  return <span className={cn('bf-badge', tone !== 'neutral' && `bf-badge--${tone}`, dot && 'bf-badge--dot')}>{children}</span>;
}

export function Count({ value, tone = 'danger', label }: { value: number; tone?: 'danger' | 'info'; label?: string }) {
  if (value <= 0) return null;
  return (
    <span className={cn('bf-count', tone === 'info' && 'bf-count--info')} aria-label={label ?? `${value} sin leer`}>
      {value > 99 ? '99+' : value}
    </span>
  );
}

export function Avatar({ name }: { name: string }) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');
  return (
    <span className="bf-avatar" aria-hidden>
      {initials || '?'}
    </span>
  );
}
